export const CHATBOT = {
  HEADER: {
    TITLE: 'Assistant',
    TOOLTIP_NEW: 'New conversation',
    TOOLTIP_HISTORY: 'Conversation history',
  },
  DISCLAIMER: 'Answers are generated by AI, which can make mistakes. Please always review the provided answer.',
}
